import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import {
  FaPhone,
  FaMapMarkerAlt,
  FaGlobe,
  FaBirthdayCake,
  FaBoxOpen,
  FaLock,
  FaEdit,
} from "react-icons/fa";

const ProfilePage = ({ loggedInUser, handleLogout }) => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchProfileData = async () => {
      if (!loggedInUser) return;

      try {
        // 🧠 Obtener datos del perfil
        const { data: profileData, error: profileError } = await supabase
          .from("user_profiles")
          .select("*")
          .eq("id", loggedInUser.id)
          .single();

        if (profileError) throw profileError;
        setProfile(profileData);
      } catch (err) {
        console.error("Error cargando perfil:", err);
      }
    };

    fetchProfileData();
  }, [loggedInUser]);

  if (!profile)
    return (
      <p style={{ textAlign: "center", marginTop: "60px" }}>Cargando perfil...</p>
    );

  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "40px 20px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      {/* 🧍 Información del usuario */}
      <div style={{ textAlign: "center", marginBottom: "40px" }}>
        <img
          src={profile.avatar_url || "/default-avatar.png"}
          alt="avatar"
          style={{
            width: "140px",
            height: "140px",
            borderRadius: "50%",
            objectFit: "cover",
            border: "3px solid #f4ddd6",
          }}
        />
        <h2
          style={{
            marginTop: "20px",
            textTransform: "capitalize",
            color: "#222",
          }}
        >
          {profile.nombre}
        </h2>
        <p style={{ color: "#555" }}>{profile.email}</p>
      </div>

      {/* 📋 Datos personales */}
      <div
        style={{
          backgroundColor: "#fff6f6",
          borderRadius: "10px",
          padding: "25px",
          marginBottom: "30px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
        }}
      >
        <p>
          <FaPhone color="#e74c3c" /> <strong>Teléfono:</strong>{" "}
          {profile.telefono || "—"}
        </p>
        <p>
          <FaMapMarkerAlt color="#e74c3c" /> <strong>Dirección:</strong>{" "}
          {profile.direccion || "—"}
        </p>
        <p>
          <FaGlobe color="#e74c3c" /> <strong>País:</strong>{" "}
          {profile.pais || "—"}
        </p>
        <p>
          <FaBirthdayCake color="#e74c3c" />{" "}
          <strong>Fecha de nacimiento:</strong>{" "}
          {profile.fecha_nacimiento || "—"}
        </p>
      </div>

      {/* 🧾 Historial de pedidos */}
      <div
        style={{
          backgroundColor: "#fff6f6",
          borderRadius: "10px",
          padding: "25px",
          marginBottom: "40px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
        }}
      >
        <h3 style={{ color: "#27ae60", marginBottom: "15px" }}>
          <FaBoxOpen /> Historial de pedidos
        </h3>
        <p style={{ color: "#777" }}>No hay pedidos registrados.</p>
      </div>

      {/* 🔘 Botones */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
        }}
      >
        <button
          style={{
            background: "#4B6CB7",
            color: "white",
            border: "none",
            borderRadius: "8px",
            padding: "10px 20px",
            fontSize: "15px",
            cursor: "pointer",
          }}
        >
          <FaEdit /> Editar perfil
        </button>

        <button
          onClick={handleLogout}
          style={{
            background: "#e74c3c",
            color: "white",
            border: "none",
            borderRadius: "8px",
            padding: "10px 20px",
            fontSize: "15px",
            cursor: "pointer",
          }}
        >
          <FaLock /> Cerrar sesión
        </button>
      </div>
    </div>
  );
};

export default ProfilePage;
